<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Receipt From Production" active>

                                <b-row v-if="hasFailedDataReceiptFromProduction">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedReceiptFromProduction.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductionsFailed" :fields="fieldsReceiptFromProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProduction" :sort-desc.sync="sortDescReceiptFromProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedReceiptFromProduction.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductions" :fields="fieldsReceiptFromProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProduction" :sort-desc.sync="sortDescReceiptFromProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Receipt From Production Material" active>

                                <b-row v-if="hasFailedDataReceiptFromProductionMaterial">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedReceiptFromProductionMaterial.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductionMaterialsFailed" :fields="fieldsReceiptFromProductionMaterial" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProductionMaterial" :sort-desc.sync="sortDescReceiptFromProductionMaterial" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyTaken)="row">
													{{ Number(row.item.qtyTaken).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedReceiptFromProductionMaterial.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductionMaterials" :fields="fieldsReceiptFromProductionMaterial" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProductionMaterial" :sort-desc.sync="sortDescReceiptFromProductionMaterial" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyBefore)="row">
													{{ Number(row.item.qtyBefore).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(qtyTaken)="row">
													{{ Number(row.item.qtyTaken).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Receipt From Production Case" active>

                                <b-row v-if="hasFailedDataReceiptFromProductionCase">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedReceiptFromProductionCase.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductionCasesFailed" :fields="fieldsReceiptFromProductionCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProductionCase" :sort-desc.sync="sortDescReceiptFromProductionCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyMaterial)="row">
													{{ Number(row.item.qtyMaterial).toLocaleString() }}
												</template>
												<template #cell(qtyCase)="row">
													{{ Number(row.item.qtyCase).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedReceiptFromProductionCase.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="receiptFromProductionCases" :fields="fieldsReceiptFromProductionCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByReceiptFromProductionCase" :sort-desc.sync="sortDescReceiptFromProductionCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyMaterial)="row">
													{{ Number(row.item.qtyMaterial).toLocaleString() }}
												</template>
												<template #cell(qtyCase)="row">
													{{ Number(row.item.qtyCase).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
import ReceiptFromProductionList from '@/models/ReceiptFromProduction/ReceiptFromProductionList';
import ReceiptFromProductionFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsReceiptFromProduction: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order", key: 'workOrderProcessDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsReceiptFromProductionMaterial: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Source Material", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Before", key: 'qtyBefore', sortable: false},
				{"class" : "th-status", "label" : "Qty After", key: 'qtyAfter', sortable: false},
				{"class" : "th-status", "label" : "Qty Taken", key: 'qtyTaken', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsReceiptFromProductionCase: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Material", key: 'qtyMaterial', sortable: false},
				{"class" : "th-status", "label" : "Qty Case", key: 'qtyCase', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			receiptFromProductions : [],
			receiptFromProductionsFailed: [],
			receiptFromProductionId : '',
			sortByReceiptFromProduction: '',
			sortDescReceiptFromProduction: '',
			hasFailedDataReceiptFromProduction: false,
			totalFailedReceiptFromProduction: 0,
			totalSucceedReceiptFromProduction: 0,
			receiptFromProductionMaterials : [],
			receiptFromProductionMaterialsFailed: [],
			receiptFromProductionMaterialId : '',
			sortByReceiptFromProductionMaterial: '',
			sortDescReceiptFromProductionMaterial: '',
			hasFailedDataReceiptFromProductionMaterial: false,
			totalFailedReceiptFromProductionMaterial: 0,
			totalSucceedReceiptFromProductionMaterial: 0,

			receiptFromProductionCases : [],
			receiptFromProductionCasesFailed: [],
			receiptFromProductionCaseId : '',
			sortByReceiptFromProductionCase: '',
			sortDescReceiptFromProductionCase: '',
			hasFailedDataReceiptFromProductionCase: false,
			totalFailedReceiptFromProductionCase: 0,
			totalSucceedReceiptFromProductionCase: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('receiptfromproduction/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('receiptfromproduction/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getReceiptFromProductionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getReceiptFromProductionForUpload : async function() {
			let _this = this;
			this.$http.get('receiptfromproduction/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.receiptFromProductions = [];
_this.receiptFromProductionMaterials = [];
_this.receiptFromProductionCases = [];


					if (response != null) {
						let result = response.data;
						_this.receiptFromProductions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedReceiptFromProduction = _this.receiptFromProductions.length;

						_this.receiptFromProductionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataReceiptFromProduction = true;
						_this.totalFailedReceiptFromProduction = 0;
						if(_this.receiptFromProductionsFailed == undefined || _this.receiptFromProductionsFailed.length === 0) _this.hasFailedDataReceiptFromProduction = false;
						if(_this.hasFailedDataReceiptFromProduction) _this.totalFailedReceiptFromProduction = _this.receiptFromProductionsFailed.length;
						_this.receiptFromProductionMaterials = [];
						_this.receiptFromProductionMaterialsFailed = [];
						_this.hasFailedDataReceiptFromProductionMaterial = true;
						_this.totalSucceedReceiptFromProductionMaterial = 0;
						result.forEach(function(element) {
							_this.receiptFromProductionMaterials.push(...element.receiptFromProductionMaterial.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedReceiptFromProductionMaterial = _this.receiptFromProductionMaterials.length;

							_this.receiptFromProductionMaterialsFailed.push(...element.receiptFromProductionMaterial.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.receiptFromProductionMaterialsFailed == undefined || _this.receiptFromProductionMaterialsFailed.length === 0) _this.hasFailedDataReceiptFromProductionMaterial = false;
							if(_this.hasFailedDataReceiptFromProductionMaterial) _this.totalFailedReceiptFromProductionMaterial = _this.receiptFromProductionMaterialsFailed.length;
						});						_this.receiptFromProductionCases = [];
						_this.receiptFromProductionCasesFailed = [];
						_this.hasFailedDataReceiptFromProductionCase = true;
						_this.totalSucceedReceiptFromProductionCase = 0;
						result.forEach(function(element) {
							_this.receiptFromProductionCases.push(...element.receiptFromProductionCase.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedReceiptFromProductionCase = _this.receiptFromProductionCases.length;

							_this.receiptFromProductionCasesFailed.push(...element.receiptFromProductionCase.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.receiptFromProductionCasesFailed == undefined || _this.receiptFromProductionCasesFailed.length === 0) _this.hasFailedDataReceiptFromProductionCase = false;
							if(_this.hasFailedDataReceiptFromProductionCase) _this.totalFailedReceiptFromProductionCase = _this.receiptFromProductionCasesFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'receiptfromproduction/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ReceiptFromProduction.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterReceiptFromProduction = new ReceiptFromProductionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
